<template>
  <div class="projects">
    <h1>🛠 Projects 🛠</h1>
    <ProjectChunk
      projectAnchor="games"
      projectTitle="Games"
      >
      <div slot="projectContent">
        <img alt="Games" src="../assets/bulletHeck.gif" rel="preload">
        <p>
          I have been noodling around with various attempts at game programming for fun and mostly with the assistance of AI to speed up the learning process.
        </p>
        <p>So far I have experimented with Love2d and vanilla JS</p>
        <p>You can have a play with some of my attempts <a href="https://www.lewismckeown.com/assets/Games/index.html" target="_blank">here</a>.</p>
      </div>
    </ProjectChunk>
    <ProjectChunk
      projectAnchor="climate"
      projectTitle="Climate Spiral Visualisation"
      >
      <div slot="projectContent">
        <img alt="Climate spiral animation with P5" src="../assets/climate-spiral.gif" rel="preload">
        <p>
          I used the <a href="https://data.giss.nasa.gov/gistemp/" target="_blank">NASA GISS Global surface temperature data</a> to recreate climate scientist Ed Hawkins' <a href="https://ed-hawkins.github.io/climate-visuals/spirals.html" target="_blank">Climate Spiral animation</a>.
        </p>
        <p>You can see it in action <a href="https://www.lewismckeown.com/assets/climate/index.html" target="_blank">here</a>.</p>
      </div>
    </ProjectChunk>
    <ProjectChunk
      projectAnchor="dnd"
      projectTitle="DND Character Generator"
      >
      <div slot="projectContent">
        <img alt="DND Character generator Demo" src="../assets/character-generator.gif" rel="preload">
        <p>In an effort to become even <i>more</i> of a nerd I decided to use machine learning to generate dungeons and dragons characters. 
           I used GPT2 to generate name, race and class combinations, then used these as the seed to generate a bio using <a href="https://ml5js.org/" target="_blank">ml5.js</a>'s charRNN model.
        </p>
        <p>You can play with it <router-link to="/dnd">here</router-link>.</p>
      </div>
    </ProjectChunk>
    <ProjectChunk
      projectAnchor="ent"
      projectTitle="Entity Analysis"
      >
      <div slot="projectContent">
        <img alt="Entity analysis demo" src="../assets/entity-analysis-asf.gif" rel="preload">
        <p>As a research project at work I implemented real time entity analysis in one of our existing applications using the <a href="https://spacy.io/api/doc" target="_blank">SpaCy API</a>. This work inlcuded the entire process from researching appropriate tools for our needs, to deployment and integration with the existing application.</p>
        <p>You can play with a demo of the features I implemented <router-link to="/entity-analysis">here</router-link>.</p>
      </div>
    </ProjectChunk>

    <ProjectChunk
      projectAnchor="fri"
      projectTitle="Freischwimmer-o-matic"
      >
      <div slot="projectContent">
        <img alt="Entity analysis demo" src="../assets/fs.png">
        <p>I made a piece of work inspired by <a href="https://www.staedelmuseum.de/en/collection/freischwimmer-54-1994" target="_blank">Wolfgang Tillmans Freischwimmer series</a> that generates works in a similar style, view it <a href="https://www.lewismckeown.com/assets/freischwimmer/index.html" target="_blank">here</a>.</p>
      </div>
    </ProjectChunk>

    <ProjectChunk
      projectAnchor="hackDay"
      projectTitle="Fivium Hack Days"
      >
      <div slot="projectContent">
        <img alt="Fivium Hack Day Logo" src="../assets/fivHackDay.png">
        <p>I have taken part in three <a href="http://www.fivium.co.uk/hackday/" target="_blank">Fivium Hack Days</a>, winning prizes in all three. Developing a carbon emmisions journey calculator, a hipchat bot that 'helps' to arrange lunch, and a chrome plugin to replace all images on a webpage with a random selection of our Jenkins images of the day.</p>
      </div>
    </ProjectChunk>

    <ProjectChunk
      projectAnchor="p5"
      projectTitle="P5 Sketches"
      >
      <div slot="projectContent">
        <img alt="p5 demo" src="../assets/trappedKnight.png">
        <p>I have been experimenting with <a href="https://p5js.org" target="_blank">p5.js</a> and am loving it, see my work <a href="assets/P5Sketches/index.html" target="_blank">here</a> and on <a href="https://github.com/lewismck/p5Playground" target="_blank">github</a>.</p>
      </div>
    </ProjectChunk>
  </div>
</template>

<script>
import ProjectChunk from '../components/ProjectChunk'

export default {
  name: 'Projects',
  components: {
    ProjectChunk
  },
}
</script>
